import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import {
  DialogActions,
  Button,
  Typography,
  Divider,
  DialogContent,
  Dialog,
} from "@material-ui/core";
import appConstants from "../../../../../../appConstants";
import { observer, inject } from "mobx-react";
import PickupShipmentCard from "./PickupShipmentCard/index";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import PickupDetails from "./PickupDetails";
import CustomConfirmationDialog from "../common/CustomConfirmationDialog";
import {
  getDefaultPickupStopInfo,
  getDefaultShipmentData,
  getCountryList,
  getExcessiveShipmentList,
  getPriorityShipmentList
} from "./util";
import ShipmentBadgeList from "../common/ShipmentBadgeList";
import {
  getDateWithUtcHoursAndMinFromTimeString,
} from "../../../../../dataGrid/gridUtilities";
import PickupDialogActions from "./PickupDialogActions";
import { postData, getDataWithQueryString } from "../../../../../../api/componentAPIs";
import Events from "../../../../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import DialogTitle from "./DialogTitle";
import { getAccessorialsAfterExclusion } from "../common/utils";
import {
  getDefaultStopTimeInfo,
  getStopTimeFieldError,
  getStopTimeErrorInfo,
  isStopTimeDetailsInValid,
  getStopTimeWithOffset,
} from "../EditStopDialog/util";
import { trackEvent } from "../../../../../common/AppInsightsEventTracking";
import { withProValidationHOC } from "./ProNumberValidation";
import constants from "./constants";

@inject("DispatchStore")
@observer
class ProcessPickupStopDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editBillsDataArray: getDefaultPickupStopInfo({
        getProNumber: this.props.proValidation.getProNumber,
        stopData: this.props.stopData,
        proNumberLength: this.props.DispatchStore.staticClientData?.clientCodes?.proNumberLength
      }),
      errorMessage: null,
      allStatusRadioClicked: false,
      pickupInfo: this.getPickupInfo(),
      pickupErrorInfo: this.getPickupErrorInfo(),
      isIncompleteEntryExist: false,
      stopTimeInfo: this.getStopTimeInfo()
    };
    this.inputRefs = [];
    this.accessorialList = this.props.DispatchStore.pickupAccessorials.map(
      (accessorial) => {
        return { isChecked: false, ...accessorial };
      }
    );
    this.priorityShipmentsList = getPriorityShipmentList(
      this.props.DispatchStore.priorityShipmentOptions
    );
    this.excessiveShipmentList = getExcessiveShipmentList();
    this.packageTypeList = this.props.DispatchStore.packageCodes;
    this.countryList = getCountryList();
    this.pickupDetailsRef = React.createRef();
    this.limitedAccessList = this.props.DispatchStore.limitedAccessList;
    this.consigneeList=[];
    this.modalMessage = this.props.isAddProToCompletedPickupFlow ? constants.ADD_PRO_TO_PICKUP : constants.PROCESS_PICKUP;
  }

  componentDidUpdate(prevProps) {
    if (this.props.isDriverArrived !== prevProps.isDriverArrived) {
      this.setNewArrivalStopTime();
    }
  }

  componentDidMount() {
    Events.on("PickupCompleted", this.showPickupCompletedStatus);
    this.getShipperConsigneeList();
  }

  componentWillUnmount() {
    Events.removeListener("PickupCompleted", this.showPickupCompletedStatus);
  }

  getShipperConsigneeList = () => {
    getDataWithQueryString(
      "GetShipperConsignee",
      `terminalCode=${this.props.userData.userProfile.terminal.code}&driverId=${this.props.routeData.driverId}`
    )
      .then((response) => {
        if (response && response.status === 200) {
          this.consigneeList = response.data;
        } else {
          this.consigneeList = [];
        }
      })
      .catch((_error) => {
        this.consigneeList = [];
      });
  };

  getStopTimeInfo = () => {
    const { stopData, isDriverArrived, isAddProToCompletedPickupFlow } = this.props;
    if (isAddProToCompletedPickupFlow) {
      return {
        stopTime: {
          arrivalTime: stopData.actualArrivalTime,
          departureTime: stopData.actualDepartureTime,
        },
        stopTimeError: {
          arrivalTime: null,
          departureTime: null,
        },
      }
    }
    return getDefaultStopTimeInfo(isDriverArrived, stopData.actualArrivalTime);
  }

  setNewArrivalStopTime = () => {
    const {
      isDriverArrived,
      stopData: { actualArrivalTime },
    } = this.props;
    this.setState((prevState) => ({
      ...prevState,
      stopTimeInfo: {
        ...prevState.stopTimeInfo,
        stopTime: {
          ...prevState.stopTimeInfo.stopTime,
          arrivalTime:
            isDriverArrived && actualArrivalTime
              ? getDateWithUtcHoursAndMinFromTimeString(actualArrivalTime)
              : null,
        },
      },
    }));
  };

  getPickupInfo = () => {
    return {
      isShipperLoadAndCount: this.props.stopData.isSLC ?? false,
      isNoFreight: false,
      isDriverAllowedInside: true,
      customerName: "",
      trailerSpaceFilled: 0,
    };
  };
  getPickupErrorInfo = () => {
    return {
      customerName: null,
      isShipperLoadAndCount: null,
      isNoFreight: null,
      isDriverAllowedInside: null,
      trailerSpaceFilled: null,
    };
  };

  handleStopTimeChange = (name) => (value) => {
    this.setState(
      (prevState) => ({
        stopTimeInfo: {
          ...prevState.stopTimeInfo,
          stopTime: {
            ...prevState.stopTimeInfo.stopTime,
            [name]: value,
          },
        },
      }),
      () => {
        this.updateStopTimeErrors(name);
      }
    );
  };

  updateStopTimeErrors = (name) => {
    this.setState((prevState) => {
      const prevStopTime = prevState.stopTimeInfo.stopTime;
      const prevStopError = prevState.stopTimeInfo.stopTimeError;
      return {
        stopTimeInfo: {
          ...prevState.stopTimeInfo,
          stopTimeError: {
            arrivalTime:
              name === "arrivalTime"
                ? getStopTimeFieldError(
                  "arrivalTime",
                  prevStopTime.arrivalTime,
                  prevStopTime
                )
                : prevStopError.arrivalTime,
            departureTime:
              name === "departureTime" || prevStopTime.departureTime
                ? getStopTimeFieldError(
                  "departureTime",
                  prevStopTime.departureTime,
                  prevStopTime
                )
                : prevStopError.departureTime,
          },
        },
      };
    });
  };

  updateStop = (apiName, requestParams) => {
    this.showLoaderDialog();
    trackEvent("Complete_Pickup", this.props.userData.userProfile, {
      eventData: requestParams
    });
    postData(apiName, requestParams).then((response) => {
      if (response && Math.trunc(response.status / 100) !== 2) {
        this.showFailedNotification();
        this.hideLoaderDialog();
      }
    });
  };

  showPickupCompletedStatus = (data) => {
    const { success } = data;
    if (success) {
      this.props.enqueueSnackbar(this.modalMessage.MESSAGES.SUCCESS, {
        variant: "success",
      });
      this.props.handleClose();
    } else {
      this.showFailedNotification();
    }
    this.hideLoaderDialog();
  };


  showLoaderDialog = () => {
    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      this.modalMessage.LOADER,
    ]);
  };

  hideLoaderDialog = () => {
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
  };

  showFailedNotification = () => {
    this.props.enqueueSnackbar(this.modalMessage.MESSAGES.FAILED, {
      variant: "error",
    });
  };

  completePickup = () => {
    const { editBillsDataArray, isIncompleteEntryExist } = this.state;
    this.setState({
      isIncompleteEntryExist: false
    })
    const bills = isIncompleteEntryExist
      ? this.getCompletedPros()
      : editBillsDataArray;
    this.updatePickupStop(bills);
  };

  handleCompletePro = (shipmentId, updatedData) => {
    let updatedArr = [];
    this.state.editBillsDataArray.forEach((shipment) => {
      if (shipment.shipmentId === shipmentId) {
        shipment.editInfo = { ...updatedData };
        shipment.isUpdatedAtLeastOnce = true;
        shipment.pickupStatus = appConstants.PICKUP_STATUS.COMPLETED;
        updatedArr.push(shipment);
      } else {
        updatedArr.push(shipment);
      }
    });
    this.setState({
      editBillsDataArray: updatedArr,
      isAddProClicked: false,
    });
  };

  clearEnteredProData = (name, value) => {
    const defaultStopsData = getDefaultPickupStopInfo({
      getProNumber: this.props.proValidation.getProNumber,
      stopData: this.props.stopData,
      proNumberLength: this.props.DispatchStore.staticClientData?.clientCodes?.proNumberLength
  });
    this.setState((prevState) => ({
      editBillsDataArray: defaultStopsData,
      isAddProClicked: false,
      pickupInfo: {
        ...prevState.pickupInfo,
        [name]: value,
      },
    }));
  };

  handlePickupLevelData = (name) => (value) => {
    if (name === "isNoFreight") {
      this.clearEnteredProData(name, value);
    } else {
      this.setState((prevState) => ({
        pickupInfo: {
          ...prevState.pickupInfo,
          [name]: value,
        },
        pickupErrorInfo: {
          ...prevState.pickupErrorInfo,
          [name]: prevState.pickupInfo.isNoFreight
            ? this.getNoFreightEntryFieldError(name, value)
            : null,
        },
      }));
    }
  };

  getExcessiveShipment = (value) => {
    switch (value) {
      case appConstants.EXCESSIVE_SHIPMENT.YES:
        return "1";
      case appConstants.EXCESSIVE_SHIPMENT.NO:
        return "0";
      default:
        return appConstants.EXCESSIVE_SHIPMENT.CAN_NOT_SEE;
    }
  };
  getAccessorialsArray = (editInfo) => {
    const { accessorialExclusionList } =
      this.props.DispatchStore.getStaticClientData().clientCodes;
    const selectedAccessorials = editInfo.accessorials
      .filter((accessorial) => accessorial.isChecked)
      .map((accessorial) => accessorial.name);
    return selectedAccessorials.length === 0
      ? selectedAccessorials
      : getAccessorialsAfterExclusion({
        selectedAccessorials,
        accessorialExclusionList,
        isLiftgateTrailer: this.props.routeData.trailer.isLiftGate,
      });
  };

  getValidPackageItems = (packagingItems) => {
    return packagingItems.filter(i => (i.hu || i.hu === 0) && i.packageCode);
  }

  populateRequestData = (shipment) => {
    return {
      ...shipment,
      accessorials: this.getAccessorialsArray(shipment),
      excessiveLength: parseInt(shipment.excessiveProLength) || 0,
      excessiveLengthShipment: this.getExcessiveShipment(
        shipment.isExcessiveLength
      ),
      weight: parseInt(shipment.weight),
      pieces: parseInt(shipment.pieces),
      packageDetails: this.getValidPackageItems(shipment.packagingItems),
      packagingItems: undefined,
      isProPreAssigned: undefined,
      isExcessiveLength: undefined,
      excessiveProLength: undefined // undefined properties are not required as part of request data
    };
  };

  updatePickupStop = (completedProsArray) => {
    const {
      routeData,
      stopData,
      userData: {
        userProfile: { terminal }
      }
    } = this.props;
    const {
      pickupInfo: {
        isShipperLoadAndCount,
        isDriverAllowedInside,
      },
      stopTimeInfo: { stopTime }
    } = this.state;
    const { arrivalTime, departureTime } = getStopTimeWithOffset(stopTime, terminal.offset);
    let finalArr = [];
    completedProsArray.forEach((shipment) => {
      finalArr.push(this.populateRequestData(shipment.editInfo));
    });
    const updateProData = {
      driverId: routeData.driverId,
      terminalCode: terminal.code,
      routeId: routeData.routeId,
      stopId: stopData.stopId,
      pickupId: stopData.pickupId,
      isSLC: isShipperLoadAndCount,
      isDriverAllowedInside,
      arrivalTime,
      departureTime,
      trailerSpaceFilled: 0,// defaulting to 0 since dispatcher doesn't need add this information 
      shipments: [...finalArr],
    };
    this.updateStop("UpdatePickupStop", updateProData);
  };

  handleAddProToCompletedPickup = () => {
    const { routeData, stopData, userData } = this.props;
    let finalArr = [];
    const { editBillsDataArray } = this.state;
    const isIncompleteStopExists = editBillsDataArray.some(
      (shipment) => shipment.pickupStatus === appConstants.PICKUP_STATUS.WAITING
    );
    if (isIncompleteStopExists) {
      this.setState({
        isIncompleteEntryExist: true,
      });
      return;
    }
    editBillsDataArray.forEach((shipment) => {
      if (!shipment.isCompletedPro) {
        finalArr.push(this.populateRequestData(shipment.editInfo));
      }
    });
    const addProData = {
      driverId: routeData.driverId,
      terminalCode: userData.userProfile.terminal.code,
      routeId: routeData.routeId,
      stopId: stopData.stopId,
      pickupId: stopData.pickupId,
      shipments: [...finalArr],
    };
    this.updateStop("AddProToCompletedPickup", addProData);
  };

  handleSubmit = (pickupType) => {
    if (pickupType === "noFreight") {
      this.handleNoFreightEntry();
    } else if (this.props.stopData.isStopCompleted) {
      this.handleAddProToCompletedPickup();
    } else {
      const errorInfo = this.getErrorInfo();
      const error = Object.values(errorInfo).filter((value) => value).length;
      const stopTimeError = this.getStopTimeError();
      if (error && stopTimeError) {
        return;
      }
      const { editBillsDataArray } = this.state;
      const isIncompleteStopExists = editBillsDataArray.some(
        (shipment) =>
          shipment.pickupStatus === appConstants.PICKUP_STATUS.WAITING
      );
      if (isIncompleteStopExists && !stopTimeError) {
        this.setState({
          isIncompleteEntryExist: true,
        });
        return;
      } else {
        !stopTimeError && this.completePickup();
      }
    }
  };

  getStopTimeError = () => {
    const stopTimeDetailsInfo = getStopTimeErrorInfo(
      this.state.stopTimeInfo.stopTime
    );
    this.setState({
      stopTimeInfo: stopTimeDetailsInfo,
    });
    return isStopTimeDetailsInValid(stopTimeDetailsInfo);
  };

  handleNoFreightEntry = () => {
    const { routeData, stopData, userData: { userProfile: { terminal } } } = this.props;
    const { pickupInfo, stopTimeInfo: { stopTime } } = this.state;
    const { arrivalTime, departureTime } = getStopTimeWithOffset(stopTime, terminal.offset);
    const errorInfo = this.getNoFreightEntryErrorInfo();
    const error = Object.values(errorInfo).filter((value) => value).length;
    const stopTimeError = this.getStopTimeError();
    if (!error && !stopTimeError) {
      const updateProData = {
        driverId: routeData.driverId,
        terminalCode: terminal.code,
        routeId: routeData.routeId,
        stopId: stopData.stopId,
        pickupId: stopData.pickupId,
        contactName: pickupInfo.customerName,
        isDriverAllowedInside: pickupInfo.isDriverAllowedInside,
        arrivalTime,
        departureTime,
      };
      this.updateStop("NoFreightPickedUp", updateProData);
    }
  };

  getNoFreightEntryFieldError = (field, value) => {
    if (field === "customerName") {
      return value && value.trim() ? null : constants.VALIDATION.CUSTOMER_NAME;
    }
  };

  getNoFreightEntryErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.pickupInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getNoFreightEntryFieldError(
        fieldName,
        this.state.pickupInfo[fieldName]
      );
    });
    this.setState({
      pickupErrorInfo: errorInfo,
    });
    return errorInfo;
  };

  getCompletedPros = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.filter(
      (shipment) =>
        shipment.pickupStatus === appConstants.PICKUP_STATUS.COMPLETED
    );
  };
  isSubmitDisabled = () => {
    const { editBillsDataArray } = this.state;
    const incompleteProsArray = editBillsDataArray.filter((shipment) =>
      shipment.isCompletedPro
        ? shipment.pickupStatus === appConstants.PICKUP_STATUS.COMPLETED
        : shipment.pickupStatus === appConstants.PICKUP_STATUS.WAITING
    );
    return incompleteProsArray.length === editBillsDataArray.length;
  };


  editProClicked = () => {
    this.setState({
      isAddProClicked: true,
    });
  };
  addPro = () => {
    const proNumberLength = this.props.DispatchStore.staticClientData?.clientCodes?.proNumberLength;
    const shipmentId = `NewShipment${this.state.editBillsDataArray.length + 1}`;
    const newArray = [
      ...this.state.editBillsDataArray,
      {
        shipmentId: shipmentId,
        editInfo: getDefaultShipmentData({getProNumber: this.props.proValidation.getProNumber, proNumberLength}),
        errorInfo: {
          packagingItemsErrorInfo: [{}],
        },
        openEditMode: true,
        initialDataExists: false,
        manualPro: true,
        pickupStatus: appConstants.PICKUP_STATUS.WAITING,
      },
    ];
    this.setState({
      editBillsDataArray: newArray,
      isAddProClicked: true,
    });
  };

  handelCancelClicked = (shipmentId) => {
    let newArray = [];
    this.state.editBillsDataArray.forEach((shipment) => {
      if (shipment.shipmentId === shipmentId) {
        if (shipment.isUpdatedAtLeastOnce || shipment.initialDataExists) {
          newArray.push(shipment);
        }
      } else {
        newArray.push(shipment);
      }
    });
    this.setState({
      editBillsDataArray: newArray,
      isAddProClicked: false,
    });
  };

  getFieldError = (field, value) => {
    switch (field) {
      case "arrivalTime":
        return value ? null : "* Required";
      case "departureTime":
        return this.getDepartureTimeError(value);
      default:
        return null;
    }
  };

  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.pickupInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.pickupInfo[fieldName]
      );
    });
    this.setState({
      pickupErrorInfo: errorInfo,
    });
    return errorInfo;
  };

  onCancelStopCompletion = () => {
    this.setState({
      isIncompleteEntryExist: false,
    });
  };


  getShipmentHu = (pickedUpShipment) => {
    return (
      pickedUpShipment.packagingItems?.reduce(
        (hu, currPackage) => (hu || 0) + (parseInt(currPackage.hu) || 0),
        0
      ) ?? 0
    );
  };

  getShipmentBadgeDetails = (pickupShipments) => {
    return {
      bills: pickupShipments?.length ?? "-",
      hu:
        pickupShipments?.reduce(
          (hu, currShipment) => hu + this.getShipmentHu(currShipment.editInfo),
          0
        ) ?? "-",
      pieces:
        pickupShipments?.reduce(
          (pieces, currShipment) =>
            pieces + (parseInt(currShipment.editInfo?.pieces) ?? 0),
          0
        ) ?? "-",
      weight:
        pickupShipments?.reduce(
          (weight, currShipment) =>
            weight + (parseInt(currShipment.editInfo?.weight) ?? 0),
          0
        ) ?? "-",
    };
  };

  isOneProComplete = () => {
    return this.state.editBillsDataArray.some(
      (shipment) =>
        shipment.pickupStatus === appConstants.PICKUP_STATUS.COMPLETED
    );
  };

  render() {
    const { classes, open, handleClose, stopData, routeData, isDriverArrived } =
      this.props;
    const {
      editBillsDataArray,
      isAddProClicked,
      pickupInfo: { isNoFreight },
      stopTimeInfo,
      pickupErrorInfo,
    } = this.state;
    const { theme } = this.props.userData.userProfile || {};
    const {
      accessorialList,
      priorityShipmentsList,
      excessiveShipmentList,
      packageTypeList,
      countryList,
      limitedAccessList,
    } = this;
    const shipmentBadgeDetails =
      this.getShipmentBadgeDetails(editBillsDataArray);
    const isSLCDisabled = this.isOneProComplete();
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${theme === "dark" ? "darkTheme" : "lightTheme"
            } `}
        >
          <DialogTitle
            handleClose={handleClose}
            id="customized-dialog-title"
            className={classes.divider}
          >
            <div>
            <span className={classes.stopName}>
              {this.modalMessage.TITLE}
            </span>
            </div>
          </DialogTitle>
          <DialogContent className="customScroll">
            <>
              <PickupDetails
                forwardRef={this.pickupDetailsRef}
                stopData={stopData}
                handleChange={this.handlePickupLevelData}
                isShipperLoadAndCount={
                  this.state.pickupInfo.isShipperLoadAndCount
                }
                isNoFreight={isNoFreight}
                pickupInfo={this.state.pickupInfo}
                pickupErrorInfo={pickupErrorInfo}
                isArrivalTimeDisabled={isDriverArrived}
                stopTimeInfo={stopTimeInfo}
                handleStopTimeChange={this.handleStopTimeChange}
                isSLCDisabled={isSLCDisabled}
                isReadOnly={this.props.isReadOnly}
              />
              {!isNoFreight && !isAddProClicked && (
                <div className={classes.manualEntryContainer}>
                  <span className={classes.manualEntryLabel}>
                    Manual Pickup Entry
                  </span>
                  <Button
                    autoFocus
                    color="primary"
                    variant="outlined"
                    className={classes.actionButton}
                    onClick={this.addPro}
                  >
                    ADD A PRO
                  </Button>
                </div>
              )}
              <Divider />
              <div>
                <Typography
                  variant="subtitle1"
                  className={classes.headerLabel}
                >
                  PICKUP DETAILS
                </Typography>
                <Typography className={classes.greenSubLabel}>
                  {`PICKUP# ${stopData.pickupNumber}`}
                </Typography>
                <ShipmentBadgeList
                  stopType={appConstants.STOP_TYPE.Pickup}
                  bills={shipmentBadgeDetails?.bills}
                  pieces={shipmentBadgeDetails?.pieces}
                  hu={shipmentBadgeDetails?.hu}
                  weight={shipmentBadgeDetails?.weight}
                />
              </div>
              <div>
                {editBillsDataArray.length > 0 &&
                  editBillsDataArray.map((obj, index) => {
                    return (
                      <PickupShipmentCard
                        key={`pickup_shipmentCard${obj.shipmentId}`}
                        index={index}
                        editInfo={obj.editInfo}
                        errorInfo={obj.errorInfo}
                        shipmentId={obj.shipmentId}
                        openEditMode={obj.openEditMode}
                        priorityShipmentsList={priorityShipmentsList}
                        excessiveShipmentList={excessiveShipmentList}
                        packageTypeList={packageTypeList}
                        accessorialList={accessorialList}
                        countryList={countryList}
                        handleCancel={this.handelCancelClicked}
                        handleCompletePro={this.handleCompletePro}
                        pickupStatus={obj.pickupStatus}
                        editProClicked={this.editProClicked}
                        isNoFreight={isNoFreight}
                        routeData={routeData}
                        limitedAccessList={limitedAccessList}
                        stopData={stopData}
                        proNumberLength={this.props.DispatchStore.staticClientData?.clientCodes?.proNumberLength}
                        consigneeList={this.consigneeList}
                        completedProList={this.getCompletedPros().map(
                          ({ editInfo, shipmentId }) => ({
                            proNumber: editInfo.proNumber,
                            shipmentId,
                          })
                        )}
                        isReadOnly={obj.isCompletedPro || isNoFreight}
                      />
                    );
                  })}
              </div>
            </>
          </DialogContent>
          <div className={classes.dialogFooter}>
            <DialogActions className={classes.dialogActionsClass}>
              <PickupDialogActions
                handleSubmit={this.handleSubmit}
                handleClose={handleClose}
                submitDisabled={this.isSubmitDisabled()}
                isNoFreight={isNoFreight}
              />
            </DialogActions>
          </div>
        </Dialog>
        {this.state.isIncompleteEntryExist && (
          <CustomConfirmationDialog
            title="Incomplete Pickup Entry"
            cancelButtonLabel="Complete Pro"
            confirmButtonLabel="Continue"
            onConfirm={this.completePickup}
            onCancel={this.onCancelStopCompletion}
          >
            <div className={classes.confirmDialogContent}>
              <span>Whoops! There is an incomplete entry.</span>
              <span>
                Would you like to continue without completing remaining pickup
                entries?
              </span>
            </div>
          </CustomConfirmationDialog>
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar,
)(withProValidationHOC(ProcessPickupStopDialog));
